const pl = {
  nav: {
    home: 'Strona główna',
    services: 'Usługi',
    portfolio: 'Portfolio',
    contact: 'Skontaktuj się',
    mobileLabel: 'Menu',
    mobileNote: 'Szybki dostęp do sekcji, kontaktu i zmiany języka na mniejszych ekranach.',
  },
  hero: {
    badge: 'Profesjonalne aplikacje webowe i mobilne',
    title1: 'Tworzymy nowoczesne',
    titleGradient: 'aplikacje',
    title2: 'na każdą platformę',
    subtitle:
      'Specjalizujemy się w React, TypeScript, PWA i React Native / Expo. Budujemy szybkie, responsywne i dostępne rozwiązania — od strony wizytówkowej po kompleksową aplikację mobilną.',
    ctaPrimary: 'Nasze usługi',
    ctaSecondary: 'Skontaktuj się',
    stat0Label: 'lat doświadczenia',
    stat1Label: 'projektów',
    stat2Label: 'zadowolonych klientów',
    platformLabel: 'Bardziej uporządkowany proces dla stron firmowych, PWA i produktów mobilnych.',
    planLabel: 'Rytm pracy',
    planTitle: 'Od briefu do wdrożenia',
    planSubtitle: 'Proces ustawiony tak, żeby projekt, development i start produktu szły w jednym kierunku.',
    step0Title: 'Zakres i kierunek',
    step0Desc: 'Najpierw porządkujemy ścieżkę użytkownika, strukturę i warstwę techniczną.',
    step1Title: 'Design i development',
    step1Desc: 'Budujemy spójny interfejs, typowany frontend i wdrożenie bez przypadkowych doklejek.',
    step2Title: 'Start i iteracje',
    step2Desc: 'Na końcu domykamy wydajność, QA i przekazanie projektu gotowego do dalszego rozwoju.',
    metric0Label: 'Platformy',
    metric0Value: 'Web / PWA / Mobile',
    metric1Label: 'Stack',
    metric1Value: 'React + TypeScript',
    metric2Label: 'Proces',
    metric2Value: 'Jasny i szybki',
  },
  services: {
    tag: 'Co robimy',
    title: 'Nasze',
    titleGradient: 'usługi',
    subtitle:
      'Od prostej strony wizytówkowej po złożoną aplikację mobilną — dobieramy technologię do Twoich potrzeb.',
    learnMore: 'Dowiedz się więcej',
    web: {
      title: 'Strony Internetowe',
      desc: 'Nowoczesne, szybkie i responsywne strony w React / Next.js. SEO-friendly i zoptymalizowane pod każde urządzenie.',
    },
    pwa: {
      title: 'Aplikacje PWA',
      desc: 'Progresywne aplikacje webowe działające offline, instalowalne na urządzeniu — jak natywne apki, bez App Store.',
    },
    expo: {
      title: 'React Native / Expo',
      desc: 'Aplikacje mobilne na iOS i Android z jednego kodu. React Native z Expo — szybki development, natywna wydajność.',
    },
    webapp: {
      title: 'Aplikacje Webowe',
      desc: 'Zaawansowane aplikacje webowe — panele administracyjne, dashboardy, systemy zarządzania treścią i API.',
    },
  },
  tech: {
    tag: 'Technologie',
    title: 'Nasz',
    titleGradient: 'stack',
    subtitle:
      'Pracujemy z nowoczesnymi technologiami, które zapewniają wydajność, skalowalność i świetne DX.',
    leadLabel: 'Jak pracujemy',
    leadTitle: 'Zwarty stack dobierany do typu produktu.',
    leadSubtitle:
      'Zamiast gonić za każdym trendem, korzystamy z małego zestawu narzędzi, który porządkuje design, development i wdrożenie.',
    group0Title: 'Warstwa frontendowa',
    group0Desc: 'Do stron, landingów i interfejsów produktowych, które mają działać szybko i czytelnie.',
    group1Title: 'Aplikacje i zachowanie',
    group1Desc: 'Do mobile, dopracowanych UI systemów i bardziej złożonych flow użytkownika.',
    group2Title: 'Dane i wdrożenie',
    group2Desc: 'Do API, integracji i procesu release, który utrzymuje projekt w porządku.',
  },
  portfolio: {
    tag: 'Portfolio',
    title: 'Nasze',
    titleGradient: 'realizacje',
    subtitle:
      'Przykładowe projekty z różnych dziedzin — strony, PWA, aplikacje mobilne i systemy webowe.',
    cta: 'Omów swój projekt',
    p0: { title: 'Sklep internetowy', desc: 'Pełny e-commerce w Next.js z płatnościami, koszykiem i panelem admina.' },
    p1: { title: 'Aplikacja fitness', desc: 'Cross-platform React Native / Expo — treningi, postępy i powiadomienia push.' },
    p2: { title: 'Dashboard analityczny', desc: 'Aplikacja webowa do wizualizacji danych w czasie rzeczywistym z WebSocket.' },
    p3: { title: 'Strona nieruchomości', desc: 'Responsywna strona z wyszukiwarką ofert, mapą i filtrowaniem.' },
    p4: { title: 'Komunikator PWA', desc: 'Progresywna aplikacja czatu z trybem offline i push notifications.' },
    p5: { title: 'Aplikacja restauracji', desc: 'System zamówień online — React Expo na iOS/Android + panel webowy.' },
  },
  sales: {
    tag: 'Jak projekt idzie do przodu',
    title: 'Bardziej czytelna',
    titleGradient: 'warstwa sprzedażowa',
    subtitle:
      'Prosty układ wokół zakresu, zaufania i kolejnych kroków, żeby strona sprzedawała pracę, a nie tylko pokazywała wizualki.',
    asideLabel: 'Jeszcze przed pierwszym sprintem',
    asideTitle: 'Jasny proces i mniej domysłów.',
    asideText:
      'Celem jest ułatwienie kontaktu, szybsze ustawienie oferty i pokazanie, jak naprawdę wygląda współpraca.',
    process0Title: 'Rozmowa startowa',
    process0Desc: 'Ustalamy cel, obecne blokery i to, jakiego produktu naprawdę potrzebujesz.',
    process1Title: 'Zakres i wycena',
    process1Desc: 'Dostajesz czytelniejszą strukturę, sensowną mapę drogową i kierunek techniczny zanim ruszy development.',
    process2Title: 'Budowa i feedback',
    process2Desc: 'Projekt idzie etapami, z punktami przeglądu, zamiast jednego nieczytelnego finałowego wrzutu.',
    process3Title: 'Start i kolejny krok',
    process3Desc: 'Kończymy gotowością do wdrożenia, dopracowaniem i planem na to, co ma się wydarzyć po wersji pierwszej.',
    metric0Label: 'Czas odpowiedzi',
    metric0Value: 'Zwykle do 24 godzin',
    metric1Label: 'Typowy zakres',
    metric1Value: 'Strony, PWA i produktowe MVP',
    metric2Label: 'Model współpracy',
    metric2Value: 'Zdalnie i etapami',
    metric3Label: 'Logika stacku',
    metric3Value: 'Jeden spójny stack między platformami',
    faqTitle: 'Najczęstsze pytania przed startem',
    faq0Question: 'Czy pomagacie doprecyzować zakres, jeśli brief jest jeszcze luźny?',
    faq0Answer: 'Tak. Pierwsze rozmowy zwykle służą właśnie ustawieniu właściwego zakresu, zanim przejdziemy do szczegółów wdrożenia.',
    faq1Question: 'Czy prosta strona może później urosnąć do większej aplikacji?',
    faq1Answer: 'Tak. Stack i struktura są dobierane tak, żeby strona firmowa mogła później rozwinąć się w PWA albo produkt bez zaczynania od zera.',
    faq2Question: 'Pracujecie tylko lokalnie czy też zdalnie?',
    faq2Answer: 'Domyślnie pracujemy zdalnie. To upraszcza delivery, a nadal zostawia miejsce na uporządkowany feedback i przeglądy etapów.',
    faq3Question: 'Co jest zwykle potrzebne, żeby zacząć?',
    faq3Answer: 'Wystarczy zarys celu biznesowego, kilka referencji i przybliżony termin, żeby zacząć pierwszą rozmowę o zakresie.',
  },
  contact: {
    tag: 'Kontakt',
    title: 'Porozmawiajmy o',
    titleGradient: 'projekcie',
    subtitle:
      'Masz pomysł na stronę, aplikację PWA lub app mobilną? Napisz do nas — odpowiadamy w ciągu 24 godzin.',
    briefLabel: 'Brief projektu',
    briefTitle: 'Napisz, co chcesz zbudować',
    briefSubtitle: 'Kilka zdań wystarczy, żeby zacząć rozmowę i ustawić właściwy zakres projektu.',
    card0Label: 'Odpowiedź',
    card0Value: 'Zwykle do 24 godzin',
    card1Label: 'Najlepiej dla',
    card1Value: 'Stron firmowych, PWA i produktowych MVP',
    card2Label: 'Model pracy',
    card2Value: 'Zdalnie, z jasnymi etapami',
    nameLabel: 'Imię i nazwisko',
    namePlaceholder: 'Jan Kowalski',
    emailLabel: 'Adres e-mail',
    emailPlaceholder: 'jan@firma.pl',
    subjectLabel: 'Temat',
    subjectPlaceholder: 'np. Chcę zamówić aplikację PWA',
    messageLabel: 'Wiadomość',
    messagePlaceholder: 'Opisz swój projekt...',
    sending: 'Wysyłanie...',
    send: 'Wyślij wiadomość',
    success: 'Wiadomość wysłana! Odezwiemy się wkrótce.',
    emailLabel2: 'E-mail',
    phoneLabel: 'Telefon',
    locationLabel: 'Lokalizacja',
    locationValue: 'Irlandia Północna / zdalna współpraca',
  },
  footer: {
    desc: 'Tworzymy nowoczesne strony internetowe, aplikacje PWA i mobilne w React Expo. Profesjonalnie i na czas.',
    navTitle: 'Nawigacja',
    servicesTitle: 'Usługi',
    techTitle: 'Technologie',
    navHome: 'Strona główna',
    navServices: 'Usługi',
    navPortfolio: 'Portfolio',
    navContact: 'Kontakt',
    svcWeb: 'Strony internetowe',
    svcPwa: 'Aplikacje PWA',
    svcExpo: 'React Native / Expo',
    svcWebapp: 'Aplikacje webowe',
    copyright: 'Wszelkie prawa zastrzeżone.',
    privacy: 'Polityka prywatności',
    terms: 'Regulamin',
  },
  servicesPage: {
    tag: 'Usługi',
    title: 'Czym się',
    titleGradient: 'zajmujemy',
    subtitle: 'Kompletna oferta — od strony wizytówkowej po rozbudowaną aplikację mobilną i webową.',
    leadLabel: 'Struktura oferty',
    leadTitle: 'Cztery kierunki, jedna logika delivery.',
    leadText: 'Każdy blok odpowiada na inny typ produktu, ale sposób prowadzenia projektu pozostaje spójny od planowania do wdrożenia.',
    heroMetric0Label: 'Najlepiej dla',
    heroMetric0Value: 'Stron firmowych i MVP',
    heroMetric1Label: 'Platformy',
    heroMetric1Value: 'Web / PWA / Mobile',
    heroMetric2Label: 'Podejście',
    heroMetric2Value: 'Lekko, szybko i typowanie',
    s0: {
      tag: 'Web Development',
      title: 'Strony i aplikacje internetowe',
      desc: 'Tworzymy nowoczesne, szybkie i w pełni responsywne strony oraz aplikacje webowe. Używamy React, Next.js i TypeScript, by dostarczyć kod wysokiej jakości — z SEO, dostępnością i wydajnością jako priorytetami.',
    },
    s1: {
      tag: 'Progressive Web Apps',
      title: 'Aplikacje PWA',
      desc: 'Progresywne aplikacje webowe łączą zalety stron www z możliwościami natywnych aplikacji. Działają offline, można je zainstalować na urządzeniu i wysyłają powiadomienia push — bez App Store.',
    },
    s2: {
      tag: 'React Native & Expo',
      title: 'Aplikacje mobilne',
      desc: 'Budujemy natywne aplikacje na iOS i Android z jednego kodu w React Native z Expo. Jeden team, jedna baza kodu — dwie platformy. Expo SDK przyspiesza development i umożliwia OTA updates.',
    },
    s3: {
      tag: 'Aplikacje Webowe',
      title: 'Systemy i panele admina',
      desc: 'Zaawansowane aplikacje webowe — dashboardy analityczne, systemy CRM, panele administracyjne i API. Architektura oparta o React, TypeScript i RESTful/GraphQL backend.',
    },
  },
  portfolioPage: {
    tag: 'Portfolio',
    title: 'Nasze',
    titleGradient: 'realizacje',
    subtitle: 'Przykładowe projekty z różnych dziedzin — strony, PWA, aplikacje mobilne i systemy webowe.',
    leadLabel: 'Wybrane realizacje',
    leadTitle: 'Trzy mocniejsze przykłady zamiast ściany kart.',
    leadText: 'Liczy się to, czego potrzebował produkt, jak został ułożony i jaki model delivery miał sens.',
    metric0Label: 'Formaty',
    metric0Value: 'Web / PWA / Mobile',
    metric1Label: 'Priorytet',
    metric1Value: 'Czytelne flow i skalowalne UI',
    metric2Label: 'Perspektywa',
    metric2Value: 'Problem, efekt i realizacja',
  },
  contactPage: {
    tag: 'Kontakt',
    title: 'Napisz do',
    titleGradient: 'nas',
    subtitle: 'Odpowiadamy w ciągu 24 godzin. Chętnie porozmawiamy o Twoim projekcie.',
    leadLabel: 'Punkt startowy',
    leadTitle: 'Nie potrzebujesz idealnego briefu.',
    leadText: 'Krótki opis pomysłu, celu biznesowego albo obecnego problemu wystarczy, żeby zacząć układać właściwy projekt.',
    metric0Label: 'Pierwsza odpowiedź',
    metric0Value: 'Zwykle w jeden dzień',
    metric1Label: 'Najlepsze tematy',
    metric1Value: 'Web, PWA i produktowe MVP',
    metric2Label: 'Tryb pracy',
    metric2Value: 'Zdalnie i etapami',
  },
} as const;

export default pl;
